export const Pending = () => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      version="1.1"
      fill="red"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ic_fluent_shifts_pending_24_regular</title>
      <desc>Created with Sketch.</desc>
      <g
        id="🔍-Product-Icons"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="ic_fluent_shifts_pending_24_regular"
          fill="#212121"
          fill-rule="nonzero"
        >
          <path
            d="M6.5,12 C9.53756612,12 12,14.4624339 12,17.5 C12,20.5375661 9.53756612,23 6.5,23 C3.46243388,23 1,20.5375661 1,17.5 C1,14.4624339 3.46243388,12 6.5,12 Z M6.5,19.88 C6.15509206,19.88 5.87548893,20.1596031 5.87548893,20.5045111 C5.87548893,20.849419 6.15509206,21.1290221 6.5,21.1290221 C6.84490794,21.1290221 7.12451107,20.849419 7.12451107,20.5045111 C7.12451107,20.1596031 6.84490794,19.88 6.5,19.88 Z M17.75,3 C19.5449254,3 21,4.45507456 21,6.25 L21,17.75 C21,19.5449254 19.5449254,21 17.75,21 L11.9774077,21.0012092 C12.2742498,20.5377831 12.5138894,20.0341997 12.6863646,19.5004209 L17.75,19.5 C18.7164983,19.5 19.5,18.7164983 19.5,17.75 L19.5,6.25 C19.5,5.28350169 18.7164983,4.5 17.75,4.5 L6.25,4.5 C5.28350169,4.5 4.5,5.28350169 4.5,6.25 L4.49957906,11.3136354 C3.96580034,11.4861106 3.46221691,11.7257502 2.99879075,12.0225923 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L17.75,3 Z M6.5000438,14.0030924 C5.45209485,14.0030924 4.63575024,14.8204841 4.64666418,15.9573825 C4.64931495,16.2335122 4.87531114,16.4552106 5.15144079,16.4525598 C5.42757044,16.449909 5.64926888,16.2239129 5.6466181,15.9477832 C5.64105975,15.3687734 6.00627225,15.0030924 6.5000438,15.0030924 C6.97241724,15.0030924 7.35344646,15.3949794 7.35344646,15.9525829 C7.35344646,16.1768805 7.27815856,16.343747 7.03551615,16.6299729 L6.93650069,16.7432479 L6.67112833,17.0333231 C6.18682267,17.5748716 6.0000438,17.9254825 6.0000438,18.5006005 C6.0000438,18.7767429 6.22390142,19.0006005 6.5000438,19.0006005 C6.77618617,19.0006005 7.0000438,18.7767429 7.0000438,18.5006005 C7.0000438,18.268353 7.07645293,18.0980788 7.32379001,17.8062547 L7.42473827,17.6907646 L7.69048308,17.400276 C8.16815154,16.8660369 8.35344646,16.5185919 8.35344646,15.9525829 C8.35344646,14.8488849 7.5310877,14.0030924 6.5000438,14.0030924 Z M11.75,6 C12.1296958,6 12.443491,6.28215388 12.4931534,6.64822944 L12.5,6.75 L12.5,12 L16.2482627,12 C16.6624763,12 16.9982627,12.3357864 16.9982627,12.75 C16.9982627,13.1296958 16.7161089,13.443491 16.3500333,13.4931534 L16.2482627,13.5 L11.75,13.5 C11.3703042,13.5 11.056509,13.2178461 11.0068466,12.8517706 L11,12.75 L11,6.75 C11,6.33578644 11.3357864,6 11.75,6 Z"
            id="🎨-Color"
            fill="#808080"
          ></path>
        </g>
      </g>
    </svg>
  );
};
